// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"420":"4165c8d5","542":"11236fd4","651":"e67c2b21","942":"19e194fa"}[chunkId] + ".chunk.js";
};